import React from 'react';

const TriangleDown = ({color}) => (
  <svg id="ic_triangle_white" style={{fill: color}} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 56">
      <path d="M-0.006,-0.000 L113.131,-0.000 L56.562,56.569 L-0.006,-0.000 Z"/>
  </svg>
);

export default TriangleDown;



// WEBPACK FOOTER //
// ./src/asset/TriangleDown.js